const menuBlock = {
  menu: "Meny",
  close: "Lukk"
};

export default menuBlock;